import React from 'react'
import Register from '../pages/auth/register'
import Login from '../pages/auth/login'
import ForgotPassword from '../pages/auth/forgot-password'
import ResetPassword from '../pages/auth/reset-password'
import Dashboard from '../pages/dashboard'
import AdminControl from '../pages/adminControl'
import Clients from '../pages/client'
import ClientInfo from '../pages/client/clientInfo'
import AddEditProperty from '../pages/client/property/addEditProperty'
import Region from '../pages/region'
import CleaningDetail from '../component/cleaning/cleaningDeatail'
import Cleaners from '../pages/cleaners'
import CleanersInfo from '../pages/cleaners/cleanersInfo'
import OverView from '../pages/overview'
import Coupons from '../pages/coupons'
import Calendar from '../pages/calendar'
import Emails from '../pages/emails'
import PushNotification from '../pages/pushNotification'
import Payments from '../pages/payments'
import PricingTable from '../pages/pricingTable'
import Reports from '../pages/reports'
import Chat from '../pages/chat'
import ViewLogs from '../component/viewLogs'
import CompleteCleaning from '../component/scheduleStatus/completeCleaning'
import NewTable from '../pages/pricingTable/newTable'
import SendEmail from '../pages/emails/SendEmail'
import SendNotification from '../pages/pushNotification/sendNotification'
import CompleteCleaningForm from '../component/scheduleStatus/completeProcess/index'
import Notification from '../pages/notification'
import CleanerReportCategory from '../pages/cleanerReportCategory'
import ViewPropertyHistory from '../pages/client/property/addEditProperty/viewPropertyHistory'

export const unAuthRoutes = [
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />
  },
  {
    path: '/reset-password',
    element: <ResetPassword />
  }
]

export const authRoutes = [
  {
    path: '/',
    element: <Dashboard />
  },
  {
    path: '/index',
    element: <Dashboard />
  },
  {
    path: '/overview',
    element: <OverView />
  },
  {
    path: `/:page_name${'/complete-cleaning'}/:properties_id/cleaningDetail`,
    element: <CompleteCleaning />
  },
  {
    path: `/:page_name${'/complete-cleaning'}/:property_schedule_id`,
    element: <CompleteCleaningForm />
  },
  {
    path: '/calendar',
    element: <Calendar />
  },
  {
    path: `${'/calendar/complete-cleaning'}/:property_schedule_id`,
    element: <CompleteCleaningForm />
  },
  { path: '/admin-control', element: <AdminControl />, permission: 'adminControl' },
  {
    path: '/clients',
    element: <Clients />
  },
  {
    path: `${'/clients/clientInfo'}/:client_id`,
    element: <ClientInfo />
  },
  {
    path: `${'/clients/clientInfo'}/:client_id/cleaningDetail/:cleaning_id`,
    element: <CleaningDetail />
  },
  {
    path: `${'/cleaning-information'}/:schedule_id`,
    element: <CleaningDetail />
  },
  {
    path: `${'/clients/clientInfo'}/:client_id${'/add-property'}`,
    element: <AddEditProperty />
  },
  {
    path: `${'/new-Property'}`,
    element: <AddEditProperty />
  },
  {
    path: `${'/clients/clientInfo'}/:client_id${'/edit-property'}/:property_id`,
    element: <AddEditProperty />
  },
  {
    path: `${'/clients/clientInfo'}/:client_id${'/view-history'}/:property_id`,
    element: <ViewPropertyHistory />
  },
  {
    path: `/cleaners`,
    element: <Cleaners />
  },
  {
    path: `${'/cleaners/cleaners-info'}/:cleaner_id`,
    // path: `/cleaners-info`,
    element: <CleanersInfo />
  },
  {
    path: '/view-logs/:id',
    element: <ViewLogs />
  },
  { path: '/coupons', element: <Coupons />, permission: 'coupons' },
  { path: '/emails', element: <Emails />, permission: 'emails' },
  {
    path: '/emails/send-email',
    element: <SendEmail />,
    permission: 'sendEmail'
  },
  { path: '/push-notification', element: <PushNotification />, permission: 'pushNotifications' },
  {
    path: '/push-notification/send-push-notification',
    element: <SendNotification />,
    permission: 'sendPushNotifications'
  },
  { path: '/payments', element: <Payments />, permission: 'payments' },

  { path: '/pricing', element: <PricingTable />, permission: 'pricingTable' },
  {
    path: '/pricing/new',
    element: <NewTable />,
    permission: 'newPricingTable'
  },
  {
    path: `${'/pricing/edit'}/:pricing_table_id`,
    element: <NewTable />,
    permission: 'newPricingTable'
  },
  {},
  { path: '/regions', element: <Region />, permission: 'regions' },
  {
    path: '/cleaner-report-category',
    element: <CleanerReportCategory />,
    permission:'cleanerReportCategory'
  },
  { path: '/reports', element: <Reports />, permission: 'reports' },
  {
    path: `${'/chat'}/:user_id/:room/:room_id`,
    element: <Chat />
  },
  {
    path: '/notifications',
    element: <Notification />
  }
]
